import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export default function AppShell() {
  const { user, company, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const segment = location.pathname.split('/')[2] || 'dashboard';

  const NAV_TITLES = {
    dashboard: t('nav.dashboard'),
    invoices:  t('nav.invoices'),
    users:     t('nav.users'),
    settings:  t('nav.settings'),
  };

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  function handleNavigate(key) {
    setSidebarOpen(false);
    navigate(key === 'dashboard' ? '/dashboard' : `/dashboard/${key}`);
  }

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-slate-900/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar
        active={segment}
        onNavigate={handleNavigate}
        user={user}
        company={company}
        onLogout={handleLogout}
        open={sidebarOpen}
      />

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Topbar
          title={NAV_TITLES[segment] || segment}
          onMenuToggle={() => setSidebarOpen((v) => !v)}
        />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
